class Modal {
    constructor ($element) {
        this.$modal = $element;
        this.$modalTrigger = document.querySelectorAll('[data-modal]');
    }

    initialize () {
        this.setModal();
    }

    setModal () {
        this.$modalTrigger.forEach((trigger) => {
            trigger.addEventListener('click', function (event) {
                event.preventDefault();
                const modal = document.getElementById(trigger.dataset.modal);
                modal.classList.add('is__active');
                if (modal.classList.contains('stage__video')) {
                    const $stageSection = modal.closest('.stage');
                    $stageSection.classList.add('has--modal-active');
                }

                // close modal
                const exits = modal.querySelectorAll('.modal__exit');
                exits.forEach(function (exit) {
                    exit.addEventListener('click', function (event) {
                        event.preventDefault();
                        modal.classList.remove('is__active');

                        if (modal.classList.contains('stage__video')) {
                            const $stageSection = modal.closest('.stage');
                            $stageSection.classList.remove('has--modal-active');
                        }
                    });
                });
            });
        });
    }
}

export { Modal };
